import { languages } from 'static/config/language/languageConfig';
import { Localization } from 'static/localization/localization';

export function checkLanguageExists(langCode: string): boolean {
    let found = false;
    languages.forEach((lang) => {
        if (langCode === lang.code) {
            found = true;
            return;
        }
    });
    if (!found) {
        console.log('Code does not exist', langCode, languages);
        return false;
    } else {
        console.log('Code exists', langCode);
        return true;
    }
}

export function getExternalLinkLocalization(title: string) {
    if (title === '_survey') {
        return Localization.SURVEY;
    } else {
        return title;
    }
}
